import { Sprite } from 'pixi.js';
import { giftCounterRewardItems } from '../../../Config/Items';
import { getGameSize } from '../../../Config/Levels';
import Core from '../../../Core/Core';
import { TGameAreas, TransactionActionTypes } from '../../../DeltaTracking/ResourceParamBuilder';
// import getLogger, { ILogger } from '../../../Core/Logger';
import { gameConfig } from '../../../index';
import { HudActions, HudEmitter } from '../../../Managers/Hud/HudEmitter';
import { Popup } from '../../../Managers/Popups';
import ResourceTracking from '../../../Managers/Tracking/ResourceTracking';
import { getRandomReward, storeRewards } from '../../../State/reducers/score';
import { IInvite, IShareGiftData } from '../../../State/socialHelpers';
import HudView from '../../../View/HudView';
import { AskFrButton } from '../../Shared/Buttons/AskFrButton';
import { MapHubPopup } from '../../Shared/MapHubPopup';
import { Gifts } from './Gifts';
import { ILeaderBoardPlayer, LeaderBoard } from './LeaderBoard';
import { INews, News } from './News';
import { SocialRewardBox } from './SocialRewardBox';

/**
 * the social hub popup
 * shows an popup that fills the whole screen
 * with different social features in tabs
 * lets the player invite friends into the game
 */

// const logger: ILogger = getLogger('[SOCIALHUBPOPUP]:');

export class SocialHubPopup extends MapHubPopup {
    public leaderBoard: LeaderBoard;
    public curGiftCounter: number;
    public pending: IInvite[];
    private gifts: Gifts;
    private askButton: AskFrButton;

    constructor(hudView: HudView, pending: IInvite[], curGiftCounter: number) {
        super(
            'socialhub',
            hudView,
            gameConfig.game_width * 0.915,
            gameConfig.game_height * 0.55,
            getGameSize().gameHeight * 0.58,
            Popup.SOCIAL
        );

        this.pending = pending;
        this.curGiftCounter = curGiftCounter;
        this.hudView = hudView;
        this.alpha = 0;

        const gameSize = getGameSize();

        const leaderBoardTab = this.addTab('leaderboard');
        leaderBoardTab.alpha = 0;

        const giftsTab = this.addTab('gifts');
        giftsTab.alpha = 0;

        // todo switch back out to real news tab
        const newsTab = this.addTab('news');
        newsTab.alpha = 0;

        const coins = new Sprite(PIXI.utils.TextureCache['mapui/leaderboard-bgcoins']);
        coins.anchor.set(0.5);
        coins.x = gameSize.gameWidth / 2;
        coins.y = gameSize.gameHeight - coins.height * 0.15;

        const askButton = new AskFrButton(
            gameConfig.game_width * 0.4,
            gameConfig.game_height * 0.2,
            Core.local.getText('invite')
        );
        askButton.x = gameSize.gameWidth / 2;
        askButton.y = coins.y - coins.height * 0.2;
        askButton.scale.set(0);

        this.askButton = askButton;

        this.addChild(coins);
        this.addButton(askButton);
    }

    public async createOnLeaderboardData(
        weekData: any[],
        data: any[],
        newsData: INews[],
        canSendGifts: boolean
    ) {
        let weekly: ILeaderBoardPlayer[] = [];
        let allTime: ILeaderBoardPlayer[] = [];

        if (!data || data.length === 0) {
            allTime.push(this.createPlayerEntry());
        } else {
            allTime = [...allTime, ...Core.sdk.leaderboards.formatLeaderBoardData(data)];
        }

        if (!weekData || weekData.length === 0) {
            weekly.push(this.createPlayerEntry());
        } else {
            weekly = [...weekly, ...Core.sdk.leaderboards.formatLeaderBoardData(weekData)];
        }

        const leaderBoard = new LeaderBoard(
            this.bgTab.width,
            this.bgTab.height,
            weekly,
            allTime,
            this.pending,
            canSendGifts
        );
        this.leaderBoard = leaderBoard;
        this.addPage(this.leaderBoard);

        const gifts = new Gifts(
            this.bgTab.width,
            this.bgTab.height,
            allTime,
            this.curGiftCounter,
            canSendGifts
        );
        this.gifts = gifts;
        this.addPage(this.gifts);

        const news = new News(this.bgTab.width, this.bgTab.height, newsData);
        // this.news = news;
        this.addPage(news);
    }

    public async tweenIn(): Promise<void> {
        await super.tweenIn();
        await this.leaderBoard.tweenIn();
    }

    public cleanup() {
        this.askButton = null;
    }

    public getGiftTab() {
        return this.gifts;
    }

    public showGiftTabNotificationIcon() {
        this.tabs[1].showNotification();
    }

    /**
     * shows the player the reward if the reward counter reaches 10
     * called by hud
     */
    public async giveReward(): Promise<void> {
        const rewards = getRandomReward(giftCounterRewardItems);
        storeRewards([rewards], TransactionActionTypes.SOCIAL);
        [rewards].forEach(r => {
            ResourceTracking.sendRewardResourceEvent(
                r.id,
                r.val as number,
                TransactionActionTypes.SOCIAL,
                TGameAreas.MAP
            );
        });

        return super.giveReward(new SocialRewardBox([rewards], 'social'));
    }

    public update(sentGifts: IShareGiftData[], requestedGifts: IShareGiftData[]) {
        if (this.curActiveTab === 1) {
            // current index of gift tab
            (this.allPagesContainer.getChildAt(1) as Gifts).updateTabs(sentGifts, requestedGifts);
        }
    }

    protected handleBtn(e: PIXI.interaction.InteractionEvent) {
        if (e.currentTarget === this.askButton) {
            HudEmitter.instance.emit(HudActions.INVITE_PLAYER);
        }
    }

    private createPlayerEntry(): ILeaderBoardPlayer {
        return {
            id: 'n/a',
            name: Core.sdk.user.name,
            stars: Core.store.getState().StatePlayer.totalStars,
            isUser: true,
            url: Core.sdk.user.avatar,
        };
    }
}
